import { defaultTo } from "lodash";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useNavigate } from "../../hooks";
import AddonAlert from "../order/AddOnAlert";
import { isInternal } from "../../helpers";
export const SignQuickOrder = () => {
  const { watch, setValue } = useFormContext();
  const { handleNavigate } = useNavigate();
  const [address_info, sqft, user_id] = watch([
    "address_info",
    "order_info.sq_ft",
    "user_id",
  ]);

  const history = useHistory();

  const { street_name, street_number, street_suffix, region } = defaultTo(
    address_info,
    {}
  );
  const hasAddress = !!(
    street_name &&
    street_number &&
    street_suffix &&
    region
  );

  if (!hasAddress || !isInternal() || !user_id) return null;
  return (
    <AddonAlert
      display
      text={<p>Just need a sign post? Skip right to the end!</p>}
      handleButton={() => {
        if (!sqft) setValue("order_info.sq_ft", 1);
        handleNavigate(() => history.push("/submit"));
      }}
      buttonProps={{ sku: "8001", showPrice: true, variant: "primary" }}
      style={{ marginBottom: "1rem" }}
      className="mb-3"
    />
  );
};
